import { downloadReport } from '@api/reports';
import CustomDatePicker from '@components/common/custom-datepicker';
import ReportsHeader from '@components/reports/reports-header';
import { reports } from '@constants/index';
import { formatDateFilter } from '@utils/date-helper';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { FiDownload } from 'react-icons/fi';

const Reports: React.FC = () => {
  const [dateValues, setDateValues] = useState({
    start_date: dayjs().startOf('month').toDate(),
    end_date: dayjs().toDate(),
    add: false,
  });

  const downloadReportFn = async (type: string) => {
    try {
      await downloadReport(
        type,
        formatDateFilter(dateValues.start_date),
        formatDateFilter(dateValues.end_date),
      );
    } catch (error) {
      // error handled
    }
  };

  return (
    <section className="flex h-screen w-full flex-col bg-white">
      <ReportsHeader />
      <div className="p-2 px-4">
        <div className="border-b border-gray-300 py-2">
          <h2 id="filter-1">
            <button
              // onClick={() => setOpenFilter(!openFilter)}
              className="flex w-full items-center justify-between gap-3 py-2 font-medium text-gray-500"
            >
              <span className="flex gap-1 text-sm font-bold">
                Created Date
                <span className="text-red-500">*</span>
              </span>
              {/* {dropdownIcon(openFilter)} */}
            </button>
          </h2>
          {/* {openFilter && ( */}
          <div id="filter-1" className="flex gap-2 sm:flex-col xl:flex-row">
            <CustomDatePicker
              className="xl:w-1/3"
              maxDate={dateValues.end_date}
              date={dateValues.start_date}
              setDate={(date: Date) =>
                setDateValues({ ...dateValues, start_date: date, add: true })
              }
              placement="right"
            />
            <CustomDatePicker
              className="xl:w-1/3"
              minDate={dateValues.start_date}
              date={dateValues.end_date}
              setDate={(date: Date) =>
                setDateValues({ ...dateValues, end_date: date, add: true })
              }
            />
          </div>
          {/* )} */}
        </div>
      </div>
      <div className="p-2 px-4">
        <p className="mb-4 mt-2 text-xs font-bold text-gray-500">
          Please note: The downloaded report is generated with the filters
          applied.
        </p>

        <div className="mb-4 mt-6">
          <div className="flex items-center justify-between border-b border-gray-300 py-2">
            <h6>Login</h6>
            <button
              onClick={() => downloadReportFn(reports.login)}
              className="flex items-center gap-2 rounded-lg border border-black bg-transparent p-2 px-3 font-bold tracking-wide text-black"
            >
              <FiDownload size={15} />
              Download Report
            </button>
          </div>
          <div className="flex items-center justify-between border-b border-gray-300 py-2">
            <h6>Disbursal</h6>
            <button
              onClick={() => downloadReportFn(reports.disbursal)}
              className="flex items-center gap-2 rounded-lg border border-black bg-transparent p-2 px-3 font-bold tracking-wide text-black"
            >
              <FiDownload size={15} />
              Download Report
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reports;
